<div class="space20"><!----></div>

<form [formGroup]="specJaarrekeningFormGroup">
  <div class="row">
    <div formArrayName="specificatieJaarrekening">
      <div formGroupName="opbouw">
        <div>
          <snelstart-ui-number-form-control formControlName="winstVolgensResultatenRekening"
                                            id="winstVolgensResultatenRekening"
                                            label="winstVolgensResultatenRekening"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="aandeelInWinstVolgensResultatenRekening"
                                            id="aandeelInWinstVolgensResultatenRekening"
                                            label="aandeelInWinstVolgensResultatenRekening"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="nietAftrekbareKostenEnLasten"
                                            id="nietAftrekbareKostenEnLasten"
                                            label="nietAftrekbareKostenEnLasten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="investeringsAftrek"
                                            id="investeringsAftrek"
                                            label="investeringsAftrek"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="investeringsBijtelling"
                                            id="investeringsBijtelling"
                                            label="investeringsBijtelling"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="mutatieHIR"
                                            id="mutatieHIR"
                                            label="mutatieHIR"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="mutatieKER"
                                            id="mutatieKER"
                                            label="mutatieKER"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="mutatieFOR"
                                            id="mutatieFOR"
                                            label="mutatieFOR"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control formControlName="winstPerOnderneming"
                                            id="winstPerOnderneming"
                                            label="winstPerOnderneming"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control formControlName="totaleOmzet"
                                            id="totaleOmzet"
                                            label="totaleOmzet"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleStakingsWinst"
                                            id="totaleStakingsWinst"
                                            label="totaleStakingsWinst"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleVrijgesteldeWinst"
                                            id="totaleVrijgesteldeWinst"
                                            label="totaleVrijgesteldeWinst"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleFinancieleBaten"
                                            id="totaleFinancieleBaten"
                                            label="totaleFinancieleBaten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleBuitengewoneBaten"
                                            id="totaleBuitengewoneBaten"
                                            label="totaleBuitengewoneBaten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleInkoopkosten"
                                            id="totaleInkoopkosten"
                                            label="totaleInkoopkosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totalePersoneelskosten"
                                            id="totalePersoneelskosten"
                                            label="totalePersoneelskosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleHuisvestingskosten"
                                            id="totaleHuisvestingskosten"
                                            label="totaleHuisvestingskosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleAutokosten"
                                            id="totaleAutokosten"
                                            label="totaleAutokosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleVerkoopkosten"
                                            id="totaleVerkoopkosten"
                                            label="totaleVerkoopkosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleOverigeKosten"
                                            id="totaleOverigeKosten"
                                            label="totaleOverigeKosten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleAfschrijvingen"
                                            id="totaleAfschrijvingen"
                                            label="totaleAfschrijvingen"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleFinancieleLasten"
                                            id="totaleFinancieleLasten"
                                            label="totaleFinancieleLasten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleBuitengewoneLasten"
                                            id="totaleBuitengewoneLasten"
                                            label="totaleBuitengewoneLasten"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control formControlName="immaterieelVastActiefOpeningsbalans"
                                            id="immaterieelVastActiefOpeningsbalans"
                                            label="immaterieelVastActiefOpeningsbalans"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="materieelVastActiefOpeningsbalans"
                                            id="materieelVastActiefOpeningsbalans"
                                            label="materieelVastActiefOpeningsbalans"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="fiancieelVastActiefOpeningsbalans"
                                            id="fiancieelVastActiefOpeningsbalans"
                                            label="fiancieelVastActiefOpeningsbalans"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="voorraadActivaOpeningsbalans"
                                            id="voorraadActivaOpeningsbalans"
                                            label="voorraadActivaOpeningsbalans"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="vorderingenActivaOpeningsbalans"
                                            id="vorderingenActivaOpeningsbalans"
                                            label="vorderingenActivaOpeningsbalans"
                                            class="custom-input-150"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="effectenOpeningsbalans"
                                            id="effectenOpeningsbalans"
                                            label="effectenOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="liquideMiddelenOpeningsbalans"
                                            id="liquideMiddelenOpeningsbalans"
                                            label="liquideMiddelenOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="eigenVermogenOpeningsbalans"
                                            id="eigenVermogenOpeningsbalans"
                                            label="eigenVermogenOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="voorzieningenOpeningsbalans"
                                            id="voorzieningenOpeningsbalans"
                                            label="voorzieningenOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="kortlopendeSchuldenOpeningsbalans"
                                            id="kortlopendeSchuldenOpeningsbalans"
                                            label="kortlopendeSchuldenOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="langlopendeSchuldenOpeningsbalans"
                                            id="langlopendeSchuldenOpeningsbalans"
                                            label="langlopendeSchuldenOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="immaterieelVastActiefSlotbalans"
                                            id="immaterieelVastActiefSlotbalans"
                                            label="immaterieelVastActiefSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="materieelVastActiefSlotbalans"
                                            id="materieelVastActiefSlotbalans"
                                            label="materieelVastActiefSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="financieelVastActiefSlotbalans"
                                            id="financieelVastActiefSlotbalans"
                                            label="financieelVastActiefSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="voorraadActivaSlotbalans"
                                            id="voorraadActivaSlotbalans"
                                            label="voorraadActivaSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="vorderingenActivaSlotbalans"
                                            id="vorderingenActivaSlotbalans"
                                            label="vorderingenActivaSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="effectenSlotbalans"
                                            id="effectenSlotbalans"
                                            label="effectenSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="liquideMiddelenSlotbalans"
                                            id="liquideMiddelenSlotbalans"
                                            label="liquideMiddelenSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control formControlName="eigenVermogenSlotbalans"
                                            id="eigenVermogenSlotbalans"
                                            label="eigenVermogenSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="voorzieningenSlotbalans"
                                            id="voorzieningenSlotbalans"
                                            label="voorzieningenSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="kortlopendeSchuldenSlotbalans"
                                            id="kortlopendeSchuldenSlotbalans"
                                            label="kortlopendeSchuldenSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="langlopendeSchuldenSlotbalans"
                                            id="langlopendeSchuldenSlotbalans"
                                            label="langlopendeSchuldenSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaalActiefOpeningsbalans"
                                            id="totaalActiefOpeningsbalans"
                                            label="totaalActiefOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaalPassiefOpeningsbalans"
                                            id="totaalPassiefOpeningsbalans"
                                            label="totaalPassiefOpeningsbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaalActiefSlotbalans"
                                            id="totaalActiefSlotbalans"
                                            label="totaalActiefSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaalPassiefSlotbalans"
                                            id="totaalPassiefSlotbalans"
                                            label="totaalPassiefSlotbalans"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="beginVermogen"
                                            id="beginVermogen"
                                            label="beginVermogen"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="eindVermogen"
                                            id="eindVermogen"
                                            label="eindVermogen"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control formControlName="totaleOnttrekkingen"
                                            id="totaleOnttrekkingen"
                                            label="totaleOnttrekkingen"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleStortingen"
                                            id="totaleStortingen"
                                            label="totaleStortingen"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleKIA"
                                            id="totaleKIA"
                                            label="totaleKIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="onbenutteKIA"
                                            id="onbenutteKIA"
                                            label="onbenutteKIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="benutteKIA"
                                            id="benutteKIA"
                                            label="benutteKIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleMIA"
                                            id="totaleMIA"
                                            label="totaleMIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="onbenutteMIA"
                                            id="onbenutteMIA"
                                            label="onbenutteMIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="benutteMIA"
                                            id="benutteMIA"
                                            label="benutteMIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleEIA"
                                            id="totaleEIA"
                                            label="totaleEIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="onbenutteEIA"
                                            id="onbenutteEIA"
                                            label="onbenutteEIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="benutteEIA"
                                            id="benutteEIA"
                                            label="benutteEIA"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="totaleDIB"
                                            id="totaleDIB"
                                            label="totaleDIB"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>

          <snelstart-ui-number-form-control formControlName="maximaleDotatieFor"
                                            id="maximaleDotatieFor"
                                            label="maximaleDotatieFor"
                                            class="custom-input-125"
                                            [decimals]="0"
                                            prefix="€"
                                            align="right"
                                            [disabledControl]="true">
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </div>
  </div>
</form>
